import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AtlasLanding from "@/pages/AtlasLanding";
import AdminLeads from "@/pages/AdminLeads";
import AdminMetrics from "@/pages/AdminMetrics";
import Docs from "@/pages/Docs";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nProvider";

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AtlasLanding />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/metrics" element={<AdminMetrics />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </I18nProvider>
  );
}

export default App;
